import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";

export const chatbotQueryKey = ["chatbot"];

const useBuildingChatbotMutation = () => {
    const alert = useAlert();
    const accessToken = useAccessToken();

    const URL = `${BACKEND_DOMAIN}/chatbot`;
    // If you need to rollback to the legacy chatbot controller just use this URL!
    // const URL = `${BACKEND_DOMAIN}/single-building-chatbot/legacy`;

    return useMutation({
        mutationFn: async ({
            message,
            buildingModelUid,
            agent,
        }: {
            message: string;
            buildingModelUid: string;
            agent: string;
        }) => {
            const response = await fetch(URL, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
                body: JSON.stringify({ message, buildingModelUid, agent }),
            });

            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }

            return response.json();
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
};

const streamBuildingChatbot = async ({
    message,
    buildingModelUid,
    agent,
    accessToken,
}: {
    message: string;
    buildingModelUid: string;
    agent: string;
    accessToken: string;
}): Promise<Response> => {
    const URL = `${BACKEND_DOMAIN}/single-building-chatbot/stream`;
    const response = await fetch(URL, {
        method: "POST",
        headers: buildRequestHeaders(accessToken),
        body: JSON.stringify({ message, buildingModelUid, agent }),
    });

    if (!response.ok) {
        throw new Error(`Error ${response.status}`);
    }

    return response;
};

export { useBuildingChatbotMutation, streamBuildingChatbot };
